<script setup lang="ts">
const route = useRoute()
const routeBaseName = useRouteBaseName()

const target = useTemplateRef<HTMLDivElement>('target')

const baseRouteName = computed(() => routeBaseName(route))

const homePage = computed(() => baseRouteName.value === 'index')

const targetIsVisible = useElementVisibility(target, {
  threshold: 0.05
})
</script>

<template>
  <!-- Global page loader overlay -->
  <ThePageLoader />

  <UBanner
    v-if="!homePage"
    to="/support/shipping-information"
    target="_blank"
    title="Free complimentary shipping on all EU orders"
    :ui="{
      container: 'h-8',
      title: 'text-xs'
    }"
  />

  <TheHeader :transparent-header="homePage && targetIsVisible" />

  <HomeHeroSection v-if="homePage" ref="target" />

  <UMain>
    <slot />
  </UMain>

  <LazyTheFooter />
</template>
